import { RuntimeProtectionConfig } from './security.types';

export const RUNTIME_PROTECTION_CONFIG: RuntimeProtectionConfig = {
  consoleWarning: {
    enabled: true,
    title: 'STOP!',
    titleStyle: [
      'color: #ff1f1f',
      'font-size: 56px',
      'font-weight: 800',
      'line-height: 1.2',
      'text-shadow: 0 1px 0 #7f0000'
    ],
    message:
      'This is a browser feature intended for developers. If someone told you to copy and paste something here, it could be a scam and may give them access to your account or personal information.',
    messageStyle: [
      'color: #ffffff',
      'font-size: 18px',
      'font-weight: 700',
      'line-height: 1.5'
    ],
    learnMoreLabel: 'Learn more',
    learnMoreUrl: 'https://en.wikipedia.org/wiki/Self-XSS',
    linkStyle: [
      'color: #8ab4f8',
      'font-size: 16px',
      'font-weight: 700',
      'line-height: 1.5'
    ]
  },
  devtoolsDetection: {
    enabled: false,
    intervalMs: 1000,
    thresholdMs: 160
  }
};
